import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { MobileService } from 'src/app/services/mobile.service';
import { ModalService } from 'src/app/services/modal.service';

@Component({
    selector: 'mobile',
    templateUrl: './mobile.component.html',
    styleUrls: ['./mobile.component.scss']
})
export class MobileComponent implements OnInit {
    public power = false;

    public visible = false;

    constructor(private router: Router, private mobileService: MobileService, private modalService: ModalService, private ls: LocalStorageService) {
        this.mobileService.powerEvent.subscribe(this.handlePower.bind(this));
        this.mobileService.showMobileEvent.subscribe(this.showMobile.bind(this));

        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        window.showMobile = () => this.showMobile(true);

        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        window.hideMobile = () => this.showMobile(false);
    }

    ngOnInit() {
        this.power = this.ls.getLS('MOBILE_POWER');
        this.visible = this.ls.getLS('MOBILE_VISIBLE');
    }

    togglePower() {
        this.handlePower(!this.power);
    }

    handlePower(power: boolean) {
        if (power) {
            this.powerOn();
        } else {
            this.powerOff();
        }
        this.ls.setLS('MOBILE_POWER', this.power);
    }

    powerOn() {
        this.power = true;
        this.modalService.closeModal();

        if (!this.router.url.includes('(mobile:')) {
            this.router.navigate([{ outlets: { mobile: ['lvb-media-screens'] } }]);
        }
    }

    powerOff() {
        this.power = false;
    }

    showMobile(show: boolean) {
        this.visible = show;
        this.ls.setLS('MOBILE_VISIBLE', this.visible);
    }
}
